import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { KeyRound, Copy, Mail, MessageCircle, Loader2, User, Building2 } from "lucide-react";

export const portalOrigin = () => window.location.origin;

export const copyText = (text, msg = "Copiato") => {
  try { navigator.clipboard?.writeText(text); toast.success(msg); }
  catch (err) { console.error("Copia non riuscita:", err); }
};

export const CredBox = ({ creds, onSend, sending, smsEnabled = true }) => {
  const altLogins = [creds.email, creds.telefono]
    .map((v) => (v || "").trim())
    .filter((v) => v && v.toLowerCase() !== (creds.username || "").trim().toLowerCase());
  return (
  <div className="bg-[#007BFF]/5 border border-[#007BFF]/30 rounded-lg p-4 space-y-3" data-testid="portal-creds-box">
    <div className="flex items-center gap-2 text-sm font-bold text-[#007BFF]"><KeyRound className="h-4 w-4" />Credenziali generate</div>
    {(creds.nome || creds.building_name) && (
      <div className="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs" data-testid="creds-recipient">
        {creds.nome && <span className="inline-flex items-center gap-1 font-semibold text-foreground"><User className="h-3.5 w-3.5 text-[#007BFF]" />{creds.nome}</span>}
        {creds.building_name && <span className="inline-flex items-center gap-1 text-muted-foreground"><Building2 className="h-3.5 w-3.5" />{creds.building_name}</span>}
      </div>
    )}
    <p className="text-xs text-muted-foreground">Consegna queste credenziali al condòmino. La password è mostrata una sola volta.</p>
    {[["Indirizzo di accesso", `${portalOrigin()}/portal`], ["Utente", creds.username], ...(creds.password ? [["Password", creds.password]] : [])].map(([label, val]) => (
      <div key={label} className="flex items-center gap-2">
        <div className="w-36 shrink-0 text-[10px] uppercase tracking-wide text-muted-foreground">{label}</div>
        <input readOnly value={val} className="flex-1 bg-secondary rounded-md px-2 py-1.5 text-xs font-mono outline-none" />
        <button onClick={() => copyText(val, `${label} copiato`)} className="p-1.5 rounded-md hover:bg-secondary hover:text-[#007BFF]"><Copy className="h-3.5 w-3.5" /></button>
      </div>
    ))}
    {altLogins.length > 0 && (
      <p className="text-[11px] text-muted-foreground flex items-start gap-1.5" data-testid="creds-alt-login">
        <KeyRound className="h-3.5 w-3.5 mt-0.5 shrink-0 text-[#007BFF]" />
        Può accedere indifferentemente con l'email o con il cellulare: <span className="font-mono text-foreground">{altLogins.join(" · ")}</span>
      </p>
    )}
    {creds.password && (
      <button className="text-xs font-medium text-[#007BFF] flex items-center gap-1.5" data-testid="copy-all-creds"
        onClick={() => copyText(`Portale condòmino\nIndirizzo: ${portalOrigin()}/portal\nUtente: ${creds.username}${altLogins.length ? `\nAccesso anche con: ${altLogins.join(" / ")}` : ""}\nPassword: ${creds.password}`, "Credenziali copiate")}>
        <Copy className="h-3.5 w-3.5" />Copia tutte le credenziali
      </button>
    )}
    {onSend && creds.password && (creds.email || creds.telefono) && (
      <div className="pt-2 border-t border-[#007BFF]/15">
        <div className="text-[11px] text-muted-foreground mb-1.5">Invia le credenziali al condòmino:</div>
        <div className="flex flex-wrap gap-2">
          {creds.email && (
            <Button size="sm" variant="outline" className="h-8 text-xs" data-testid="send-creds-email" disabled={sending} onClick={() => onSend("email")}>
              {sending === "email" ? <Loader2 className="h-3.5 w-3.5 mr-1.5 animate-spin" /> : <Mail className="h-3.5 w-3.5 mr-1.5" />}Invia via email
            </Button>
          )}
          {creds.telefono && smsEnabled && (
            <Button size="sm" variant="outline" className="h-8 text-xs" data-testid="send-creds-sms" disabled={sending} onClick={() => onSend("sms")}>
              {sending === "sms" ? <Loader2 className="h-3.5 w-3.5 mr-1.5 animate-spin" /> : <MessageCircle className="h-3.5 w-3.5 mr-1.5" />}Invia via SMS
            </Button>
          )}
        </div>
      </div>
    )}
  </div>
  );
};
